import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { addFormControls } from '@shared/util/util';

@Component({
  selector: 'app-observacoes-form',
  templateUrl: './observacoes-form.component.html',
  styleUrls: ['./observacoes-form.component.scss']
})
export class ObservacoesFormComponent implements OnInit, OnChanges {

  @Input() observacoesForm!: FormGroup;
  @Input() nomePagina!: NomePaginaEnum;
  @Input() data!: any;
  nomePaginaCompleto = this.nomePagina + 'Observacoes';
  contadorCaracteres: number = 0;

  @Input() somenteVisualizar!: any;

  constructor(
    private fb: FormBuilder
  ) {}

  ngOnChanges(): void {
    this.aplicarTextoObservacao();
    this.atualizarContador();
  }

  ngOnInit(): void {
    this.construirForm();
    this.aplicarTextoObservacao();
    this.atualizarContador();
  }

  private aplicarTextoObservacao(): void {
    if (!this.observacoesForm?.get('textoObservacao')) {
      return;
    }
    const nomeObs = this.nomePagina + 'Observacoes';
    const texto = this.data?.[nomeObs]?.[0]?.textoObservacao ?? this.data?.textoObservacao;
    if (texto != null && texto !== '') {
      this.observacoesForm.patchValue({ textoObservacao: texto });
    }
  }

  construirForm(): void {
    addFormControls(this.observacoesForm, {
      textoObservacao: [''],
      entidadeObservacoes: ['']
    });

    this.textoObservacaoControl?.valueChanges.subscribe((val) => {
      if(val) {
        const textoObservacao = this.textoObservacaoControl?.value || '';
        const objEnvio = {
          textoObservacao: textoObservacao
        }
        this.observacoesForm.get('entidadeObservacoes')?.setValue([objEnvio]);
      }
    });
  }

  reset() {
    this.observacoesForm.reset();
    this.contadorCaracteres = 0; // Reseta o contador de caracteres

  }

  get textoObservacaoControl() {
    return this.observacoesForm.get('textoObservacao');
  }
  atualizarContador() {
    const valor = this.observacoesForm.get('textoObservacao')?.value || '';
    this.contadorCaracteres = valor.length;
  }
}
